import React from 'react'

import TourPage from '../tours/TourPage'
import NewTourPage from '../tours/NewTourPage'

const tourWrapper =
  (C, isNew = false) =>
  props =>
    isNew ? (
      <NewTourPage>
        <C {...props} />
      </NewTourPage>
    ) : (
      <TourPage>
        <C {...props} />
      </TourPage>
    )

export { tourWrapper }
